import $ from 'jquery';

$(() => {
  $('.wf-block-modal').each((modal_ind, modal_elem) => {
    $(`a[href="#${$(modal_elem).attr('id')}"]`).each((trigger_ind, trigger_elem) => {
      $(trigger_elem).on('click', (jqevt) => {
        jqevt.preventDefault();
        jqevt.stopImmediatePropagation();
        $(`#modal-${$(modal_elem).attr('id')}`).modal('show');
        return false;
      })
    })
  });

  $('.modal').each((ind, modal) => {
    $(modal).on('hide.bs.modal', (evt) => {
      $(evt.currentTarget).find('iframe').each((ifind, ifelem) => {
        // a bit hacky, but resetting the iframe source should stop any videos playing
        $(ifelem).attr('src', $(ifelem).attr('src'));
      });
    });
  });
});